module.exports = __webpack_public_path__ + "img/pr-6.10bdc313.png";